<template>
     <div id="course" class="app-inner">
           <div class="public-btn-div flex align-cen"  v-if="!authType">
      <div class="public-add"  @click="addCourse">
        新增课程
      </div>
    </div>
    <div class="p-tit-c">
        <div class="businessList-filter">
             <div class="businessList-filter-list flex align-cen">
            <div class="fl-le flex align-cen">
          <div class="label">课程名称：</div>
          <div class="el-select1">
            <el-input placeholder="请输入课程名称" v-model="search" clearable> </el-input>
          </div>
         </div>
             <div class="fl-rt flex align-cen">
          <div class="label">课程ID：</div>
          <div class="el-select1">
          <el-input placeholder="请输入课程ID" v-model="search1" clearable> </el-input>
          </div>
         </div>
      </div>
          <div class="businessList-filter-list flex align-cen">
              <div class="fl-le flex align-cen">
          <div class="label">课程分类：</div>
                     <el-select
                        v-model="value"
                        clearable
                        placeholder="请选择"
                        @change="classSelect"
                    >
                        <el-option
                        v-for="item in itemList"
                          :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
            </el-option>
          </el-select>
        </div>
      </div>
        <div class="businessList-filter-list flex align-cen">
        <div class="label">费用信息：</div>
        <div
          style="color: red; padding-right: 20px; cursor: pointer"
          @click="allradio(1)"
        >
          不限
        </div>
        <el-radio v-model="radio1" label="1"  @change="classSelect">免费课</el-radio>
        <el-radio v-model="radio1" label="2" @change="classSelect">付费课</el-radio>
      </div>
          <div class="businessList-filter-list flex align-cen">
        <div class="label">启用状态：</div>
        <div
          style="color: red; padding-right: 20px; cursor: pointer"
          @click="allradio(2)"
        >
          不限
        </div>
        <el-radio v-model="radio2" label="1" @change="classSelect">启用中</el-radio>
        <el-radio v-model="radio2" label="2" @change="classSelect">禁用</el-radio>
      </div>
         <div class="businessList-filter-list flex align-cen">
        <div class="label">推荐状态：</div>
        <div
          style="color: red; padding-right: 20px; cursor: pointer"
          @click="allradio(3)"
        >
          不限
        </div>
        <el-radio v-model="radio3" label="1" @change="classSelect">推荐</el-radio>
        <el-radio v-model="radio3" label="0" @change="classSelect">未推荐</el-radio>
      </div>
         <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="classSelect">
        搜索
        </div>
        <div class="public-btn-small-text" @click="reset">
        重置筛选条件 
        </div>
      </div>
        </div>
    </div>
      <div class="businessList-container">
        <div class="businessList-container-table">
                <el-table
            :data="list"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
             <el-table-column label="课程封面" align="center" prop="pic"  width="200">
            <template slot-scope="scope" >
                <img :src="scope.row.logo ? scope.row.logo : require('../../assets/images/nullimg.png')" alt="" style="display: block;width:90px;height:51px;margin:0 auto" v-if="scope.row.id !=0"> 
            </template>
             </el-table-column>
             <el-table-column prop="title" label="课程名称" align="center"  width="200">
            </el-table-column>
             <el-table-column prop="id" label="课程ID" align="center"  width="200">
            </el-table-column>
             <el-table-column prop="classifyName" label="课程分类" align="center">
            </el-table-column>
             <el-table-column prop="chapterNum" label="课时数量" align="center" >
            </el-table-column>
             <el-table-column prop="sort" label="排序" align="center">
             <template slot-scope="scope" >
              <p>{{scope.row.sort || '-'}}</p>
            </template>
            </el-table-column>
             <el-table-column label="启用状态" align="center" width="150" v-if="!authType">
            <template slot-scope="scope">
              <div class="buStatus"  @click="changeStatus(scope)">
                <el-switch
                  v-model="scope.row.state == 0 ? false : true"
                  disabled
                >
                </el-switch>
              </div>
            </template>
          </el-table-column>
           <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="350"
             v-if="!authType"
            >
             <template slot-scope="scope">
                 <el-button type="text" size="small"  slot="reference" style="color:red" @click="openExamPreview(scope.row)">预览</el-button>
                 <el-button type="text" size="small"  slot="reference" style="color:red" @click="openAssign(scope.row)">指派</el-button>
                  <el-button type="text" size="small"  slot="reference" style="color:red"  @click="openscoreAnalysis(scope.row)">数据分析</el-button>
                   <el-button type="text" size="small"  slot="reference" style="color:red" @click="openPoster(scope.row)">查看链接海报</el-button>
                    <el-button type="text" size="small"  slot="reference" style="color:red"  @click="addCourse(scope.row)">编辑</el-button>
                    <el-dropdown>
                        <span class="el-dropdown-link" style="color:red;font-size:12px;margin-left: 10px;cursor: pointer;font-weight: bold;">
                          更多<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item @click.native="changeStatus1(scope.row)">{{scope.row.recommend == 1 ? '取消推荐' : '加入推荐'}}</el-dropdown-item>
                          <el-dropdown-item @click.native="deleteC(scope.row)">删除</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
             </template>
          </el-table-column>
             <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="100"
            v-if="authType == 1"
            >
            <template slot-scope="scope">
               <el-button type="text" size="small" style="color:red" @click="emitchose(scope.row)">选择</el-button>
            </template>
               </el-table-column>
                </el-table>
                 <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
        </div>
      </div>
           <el-dialog
  title="所有规格"
  :visible.sync="centerDialogVisible2"
  width="60%"
  :append-to-body="true"
  center>

      <div class="businessList-container-table">
              <el-table
          ref="multipleTable1"
          :data="skuArr"
          tooltip-effect="dark"
          style="width: 100%"
          border
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"

        >
            <el-table-column prop="id" label="规格编号" align="center" width="200">
          </el-table-column>

          <el-table-column prop="name" label="规格名称" align="center" width="200">
          </el-table-column>
          <el-table-column  label="销售价格" align="center">
             <template slot-scope="scope">
             ￥{{scope.row.salePrice}}
            </template>
          </el-table-column>
           <el-table-column label="原价" align="center">
            <template slot-scope="scope">
             ￥{{scope.row.originalPrice}}
            </template>
          </el-table-column>
            <el-table-column  label="支撑账号个数" align="center" width="200">
              <template slot-scope="scope">
                {{scope.row.accountNum || '无限制'}}
              </template>
          </el-table-column>
           <el-table-column  label="使用期限（月）" align="center">
            <template slot-scope="scope">
                {{scope.row.deadline || '无'}}
              </template>
          </el-table-column>
           </el-table>
      </div>
       </el-dialog>
  <el-dialog
  title="分享"
  :visible.sync="centerDialogVisible3"
  width="440px"
  :append-to-body="true"
  center>
    <posterDraw 
    :propImg="propImg"
    :propText="propText" 
    :propQrcode="link" 
    :dowloadImgName="dowloadImgName" 
    :propType="propType"
    ref="posterEmit">
    </posterDraw>
</el-dialog>
     </div>
</template>
<script>
import {getAllCourseClassify,getcourseList,addCourse,courseSkuList,deletCourse} from "@/api/enterprise/index"  //课程分类、课程列表、修改课程、规格列表、删除课程
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
import mycomponents from "@/utils/compoments.js"
export default {
    name:'Course',
    components:{
      paginaTion,
      posterDraw:mycomponents.components.posterDraw
    },
      props: {
        authType:[String, Number],
        },
    data () {
        return {
          businessInfo:{},
          centerDialogVisible2:false,
          centerDialogVisible3:false,
          propImg:'https://oss.yhkz.com/2024-05-25/%E6%88%91%E7%9A%84%E8%80%83%E8%AF%95%20(2)_20240525134806.jpg',
          link:'',
          propText:'',
          dowloadImgName:'',
          propType:'',
          skuArr:[],
            search:'',
            search1:'',
            itemList:[],
            value:'',
            radio1:'',
            radio2:'',
            radio3:'',
            list:[],
            totalCount:0,
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据

        }
    },
     activated(){
        this.getList()
    },
    created () {
      this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
      if(this.authType) this.getList()
        this.getCourseClass()
    },
    methods: {
      // 打开授权用户
      openCrouseAuthC(data){
        this.$router.push({
            name: "courseAuth",
            query:{
                id:data.id,
            }
           })
      },
         // 删除课程
        deleteC(data){
             this.$confirm('确定要删除该课程吗？删除后不可恢复，请您谨慎操作', '删除课程', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
              }).then(() => {
                  deletCourse({id:data.id},'DELETE')
                  .then(res =>{
                    if(res.code == 0){
                      this.$util.Notifi('删除成功','success','fa-check')
                   this.getList()
                    }else{
                      this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                    }
                  })
              }).catch(() => {          
              });
        },
        //  父组件选择事件
            emitchose(data){
              this.$emit('sendStatus', data)
            },
      // 打开预览
      openExamPreview(data){
          this.$router.push({
            name: "previewCourse",
            query:{
                id:data.id,
            }
           })
      },
          // 打开统计分析
      openscoreAnalysis(data){
        this.$router.push({
            name: "courseData",
            query:{
                id:data.id,
            }
           })
      },
       // 打开海报
          openPoster(data){
            if(data.state == 1){
              this.centerDialogVisible3 = true
             this.propImg = data.logo 
             this.propText = data.title
             this.propType = 1
              this.dowloadImgName = data.title + '课程海报'
              this.link = this.$config.prUrl + '#/webenterpriseHlrj/enCourseDetail?id='+ data.id
            }else{
              this.$message.error('请先开启状态')
            }
          },
         // 查看规格
       seeSku(data){
        this.skuArr = []
          courseSkuList({
                id:data.id,
                businessId:this.businessInfo.id
                    })
                .then(res => {
                  this.skuArr = res.data
                })
                .catch(err => {
                })
        this.centerDialogVisible2 = true
      },
         emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.getList()
      },
      // 状态开启
              changeStatus(e){
            if(e.row.state == 1){
           this.$confirm('确认关闭吗？', '课程禁用', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                        this.editPaper(e)
                        }).catch(() => {          
                        });
        }else{
            this.editPaper(e)
        }
        },
      // 加入推荐取消
      changeStatus1(data){
        let  textCon= data.recommend == 1 ? "请问确定要取消推荐吗？ 取消后，不再在推荐模块中展示" : "请问确定要加入推荐吗？",
            textCon1 = data.recommend == 1 ? "取消推荐" : "加入推荐"
                 this.$confirm(textCon, textCon1, {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                  }).then(() => {
                  addCourse({
                id:data.id,
                businessId:this.businessInfo.id,
                recommend:data.recommend == 1 ? '0' : '1',
                    },'put')
                .then(res => {
                  if(res.code ==1){
                     this.$message.error(res.msg); 
                  }else{
                      this.$message.success('修改成功'); 
                    this.getList()
                  }
                })
                .catch(err => {
                })
                  }).catch(() => {          
                  });

      },
          editPaper(e){
             addCourse({
                id:e.row.id,
                businessId:this.businessInfo.id,
                state:e.row.state == 1 ? '0' : '1',
                    },'put')
                .then(res => {
                  if(res.code ==1){
                     this.$message.error(res.msg); 
                  }else{
                      this.$message.success('状态修改成功'); 
                    this.getList()
                  }
                })
                .catch(err => {
                })
        },
      // 获取分页列表
      getList(){
         let params = {
                isPlat:0,
                title:this.search,
                id:this.search1,
                classifyId:this.value,
                state:this.radio2,
                payType:this.radio1,
                recommend:this.radio3,
                 current: this.currentPage,
                size:this.PageSize,
                businessId:this.businessInfo.id
            }
            getcourseList(params)
            .then(res =>{
              this.list = res.data.records
             this.totalCount = res.data.total;
            })
      },
        // 筛选
        allradio(type){
            this[`radio${type}`] = ''
            this.currentPage=1
            this.getList()
        },
        classSelect(){
          this.currentPage = 1
            this.getList()
        },
        // 重置
        reset(){
          this.search = ""
          this.search1 = ""
          this.value = ''
          this.radio1 = ""
          this.radio2 = ""
          this.radio3 = "" 
          this.currentPage=1
          this.getList()
        },
        // 获取分类
        getCourseClass(){
            this.itemList = []
             getAllCourseClassify({
                name:'',
                businessId:this.businessInfo.id
             })
            .then(res => {
              if(res.data){
               this.itemList = res.data
              }else{
                    this.itemList = []
             }

            })
            .catch(err => {
            })
        },
              // 打开统计分析
      openscoreAnalysis(data){
        this.$router.push({
            name: "enCourseData",
            query:{
                id:data.id,
            }
           })
      },
        // 打开新增课程窗口
        addCourse(data){
       this.$router.push({
        name: "enAddCourse",
        query:{
            id:data.id,
        }
        })
        },
          // 打开预览
      openExamPreview(data){
          this.$router.push({
            name: "enPreviewCourse",
            query:{
                id:data.id,
            }
           })
      },
      // 打开指派
      openAssign(data){
          this.$router.push({
            name: "enCourseAssign",
            query:{
                id:data.id,
            }
           })
      },
    },
}
</script>
<style lang="scss" scoped>
#course{
         .businessList-filter {
    padding-top: 10px;
    .businessList-filter-list {
      margin-top: 20px;
      .fl-rt {
        padding-left: 30px;
      }
    }
    .businessList-filter-list:first-child {
      margin-top: 0;
    }
  }
    .businessList-container {
    .businessList-container-table {
      margin-top: 20px;
      .el-switch {
        position: relative;
        z-index: 1 !important;
      }
      .el-switch.is-disabled {
        opacity: 1 !important;
      }
      .buStatus{
        width: 50px;
        margin: 0 auto;
      }
    }
    .jiange {
      margin-top: 20px;
    }
  }
  
}
  ::v-deep {
  .el-switch.is-disabled .el-switch__core {
    cursor: pointer !important;
    width: 50px !important;
  }
  }
</style>